/* Precio profesional (B2B) en el tema — inyecta una TARJETA con el precio pro (neto, sin IVA) + la
   escalera de volumen, y OCULTA el precio del tema (inline !important, garantizado). No reescribe
   .f-price → no hay guerra ni parpadeo de seQura. Consume /api/b2b-public/prices (verifica B2B en
   servidor). Seguro: si no es B2B o la tarifa está off, no toca nada. */
(function () {
  var B = window.FRIKY_B2B;
  if (!B || !B.id) return;                                    // sin sesión de cliente
  var tags = B.tags || [];
  var isB2B = B.isB2B === true || (Array.isArray(tags) ? tags : String(tags).split(',')).some(function (t) { return String(t).trim().toLowerCase() === 'b2b'; });
  if (!isB2B) return;                                         // solo clientes B2B

  var API = window.FRIKY_B2B_API || 'https://frikyshop.fly.dev/api/b2b-public';
  var money = function (n) { return Number(n).toLocaleString('es-ES', { minimumFractionDigits: 2, maximumFractionDigits: 2 }) + ' €'; };
  var cache = {}, pending = {}, activated = null, applied = 0, injectedPids = {};

  function ensure(el, price) {
    if (!price || !(price.netB2B > 0)) return;
    el.style.setProperty('display', 'none', 'important');     // ocultar precio del tema (garantizado, cada pasada)
    var pid = el.getAttribute('data-b2b-pid');
    if (pid && injectedPids[pid]) return;                     // ya hay tarjeta para este producto → NO duplicar (oculta el 2º precio)
    var next = el.nextElementSibling;
    if (next && next.classList && next.classList.contains('fb2b-card')) return; // tarjeta ya puesta
    var parent = el.parentNode; if (!parent) return;
    var reg = el.querySelector('.f-price-item--regular') || el.querySelector('.f-price-item');
    var pvpRaw = reg ? reg.textContent.trim() : '';
    // El tema pone el € DELANTE ("€16,95"); lo dejamos DETRÁS ("16,95 €") como el resto del precio pro.
    var pvpTxt = pvpRaw ? pvpRaw.replace(/€/g, '').replace(/\s+/g, '').trim() + ' €' : '';
    var save = price.effDiscPct > 0 ? ('−' + price.effDiscPct + '%') : '';
    var fs = '', fw = '';
    try { var cs = window.getComputedStyle(reg || el); fs = cs.fontSize; fw = cs.fontWeight; } catch (e) { /* */ }
    var isMain = el.classList.contains('f-price--large') || (window.FRIKY_PRODUCT_ID && String(window.FRIKY_PRODUCT_ID) === String(pid));
    // Escalera de volumen (solo en el precio principal de la ficha).
    var volHtml = '';
    if (isMain && price.tiers && price.tiers.length) {
      var rows = price.tiers.filter(function (t) { return t.extraPct > 0 && t.netB2B && t.netB2B < price.netB2B - 0.001; });
      if (rows.length) volHtml = '<div class="fb2b-vol"><div class="fb2b-vol__h">📦 Cuanto más compras, menos pagas <span>(por unidades del pedido)</span></div>'
        + rows.map(function (t) { return '<div class="fb2b-vol__r"><span>Desde ' + t.minUnits + ' uds</span><b>' + money(t.netB2B) + '</b><em>−' + t.effDiscPct + '%</em><button type="button" class="fb2b-vol__add" data-qty="' + t.minUnits + '" title="Añadir ' + t.minUnits + ' uds">🛒 +' + t.minUnits + '</button></div>'; }).join('') + '</div>';
    }
    var card = document.createElement('div');
    card.className = 'fb2b-card' + (isMain ? ' fb2b-card--main' : '');
    card.innerHTML = '<div class="fb2b-price">'
      + (pvpTxt ? '<span class="fb2b-pvp">' + pvpTxt + '</span>' : '')
      + '<span class="fb2b-net"' + (fs ? ' style="font-size:' + fs + (fw ? ';font-weight:' + fw : '') + '"' : '') + '>' + money(price.netB2B) + '</span>'
      + '<span class="fb2b-tag">PRO</span><span class="fb2b-iva">sin IVA</span>'
      + (save ? '<span class="fb2b-save">' + save + '</span>' : '')
      + '</div>' + volHtml;
    el.insertAdjacentElement('afterend', card);
    if (pid) injectedPids[pid] = 1;
    applied++;
  }

  function sweep() {
    if (activated === false) return;
    var need = {};
    document.querySelectorAll('.f-price[data-b2b-pid]').forEach(function (el) {
      var pid = el.getAttribute('data-b2b-pid');
      if (!pid) return;
      var p = cache[pid];
      if (p === undefined) { if (!pending[pid]) need[pid] = 1; }
      else if (p) ensure(el, p);
    });
    var ids = Object.keys(need);
    if (!ids.length) return;
    ids.forEach(function (p) { pending[p] = 1; });
    fetch(API + '/prices', {
      method: 'POST', headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify({ customerId: B.id, email: B.email || '', productIds: ids, units: 0 }),
    }).then(function (r) { return r.json(); }).then(function (d) {
      if (!d || d.activated === false) { activated = false; ids.forEach(function (p) { cache[p] = null; delete pending[p]; }); return; }
      activated = true;
      ids.forEach(function (p) { cache[p] = (d.prices && d.prices[p]) ? d.prices[p] : null; delete pending[p]; });
      sweep();
    }).catch(function () { ids.forEach(function (p) { delete pending[p]; }); });
  }

  // Botones de la escalera de volumen: añaden N unidades de golpe al carrito y llevan al carrito.
  document.addEventListener('click', function (e) {
    var btn = e.target && e.target.closest ? e.target.closest('.fb2b-vol__add') : null;
    if (!btn) return;
    e.preventDefault();
    var qty = parseInt(btn.getAttribute('data-qty'), 10) || 1;
    var vinput = document.querySelector('form[action*="/cart/add"] [name="id"]:not([disabled])') || document.querySelector('form[action*="/cart"] [name="id"]') || document.querySelector('[name="id"]');
    var vid = vinput ? vinput.value : (window.FRIKY_VARIANT_ID || null);
    if (!vid) { alert('No se pudo identificar la variante del producto.'); return; }
    btn.disabled = true; var old = btn.textContent; btn.textContent = 'Añadiendo…';
    fetch('/cart/add.js', { method: 'POST', headers: { 'Content-Type': 'application/json' }, body: JSON.stringify({ id: vid, quantity: qty }) })
      .then(function (r) { if (!r.ok) throw new Error('add'); return r.json(); })
      .then(function () { window.location.href = '/cart'; })
      .catch(function () { btn.disabled = false; btn.textContent = old; alert('No se pudo añadir al carrito.'); });
  });

  // Descarga de la TARIFA B2B en Excel (botón del área profesional). Usa la sesión del cliente.
  document.addEventListener('click', function (e) {
    var el = e.target && e.target.closest ? e.target.closest('[data-b2b-catalog]') : null;
    if (!el) return;
    var fmt = el.getAttribute('data-b2b-catalog');
    if (fmt !== 'excel' && fmt !== 'pdf') return;
    e.preventDefault();
    var ep = fmt === 'pdf' ? '/catalog.pdf' : '/catalog.xlsx';
    window.location.href = API + ep + '?customerId=' + encodeURIComponent(B.id) + '&email=' + encodeURIComponent(B.email || '');
  });

  var ticks = 0;
  // Antes se paraba a los 30 ciclos (21 s): pasado ese rato, un re-render del tema dejaba
  // la ficha con el precio retail y el botón de volumen sin repintar. Ahora es permanente.
  setInterval(function () { ticks++; sweep(); }, 2500);
  try {
    var rep = false;
    new MutationObserver(function () {
      if (rep) return; rep = true;
      setTimeout(function () { rep = false; sweep(); }, 80);
    }).observe(document.body, { childList: true, subtree: true });
  } catch (e) { /* sin observer, queda el latido */ }
  sweep();
  document.addEventListener('shopify:section:load', function () { setTimeout(sweep, 150); });
})();

